import { Slot } from '@radix-ui/react-slot';
import { cn } from '@utils/cn';

import { type InformationTitleProps } from './types';

const InformationTitle = ({
  asChild = false,
  className,
  ...props
}: InformationTitleProps) => {
  const Component = asChild ? Slot : 'p';

  return (
    <Component className={cn('text-lg font-bold', className)} {...props} />
  );
};

export { InformationTitle };
